import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyBeaker = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M7 28C5.346 28 4 26.654 4 25C4 23.721 5.523 21.379 6.177 20.432C6.364 20.162 6.671 20 7 20C7.329 20 7.636 20.161 7.823 20.432C8.478 21.38 10 23.722 10 25C10 26.654 8.654 28 7 28ZM7 22.853C6.424 23.824 6.008 24.695 6 25.001C6 25.551 6.449 26 7 26C7.551 26 8 25.552 8 25.001C7.992 24.694 7.576 23.823 7 22.854V22.853Z" />
		<path d="M26.535 19.465L17.311 10.241C17.754 9.583 18 8.799 18 8C18 5.794 16.206 4 14 4C12.947 4 11.916 4.427 11.172 5.171L5.172 11.171C4.427 11.916 4 12.946 4 14C4 16.206 5.794 18 8 18C8.798 18 9.583 17.754 10.241 17.311L19.465 26.535C20.396 27.466 21.684 28 23 28C25.757 28 28 25.757 28 23C28 21.684 27.466 20.395 26.535 19.465ZM11.707 15.95L15.949 11.708L22.242 18.001H13.757L11.707 15.951V15.95ZM8 16C6.897 16 6 15.103 6 14C6 13.473 6.213 12.958 6.586 12.586L12.586 6.586C12.958 6.214 13.474 6 14 6C15.103 6 16 6.897 16 8C16 8.527 15.787 9.042 15.414 9.414L9.414 15.414C9.042 15.786 8.526 16 8 16ZM23 26C22.21 26 21.437 25.68 20.879 25.121L15.758 20H24.243L25.122 20.879C25.68 21.437 26.001 22.21 26.001 23C26.001 24.654 24.655 26 23.001 26H23Z" />
	</svg>
);

export default SafetyBeaker;
